import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";
import { Notification, TypeNotification } from "../../../models/notification";
import { NotificationServiceInstance } from "../../../services/notification.service";

@Component
export default class NotificationPanel extends Vue {
	@Prop({ default: false })
	public isVisible;

	@Prop({ default: 0 })
	public x;

	@Prop({ default: 0 })
	public y;

	@Prop()
	public width;

	@Prop({ default: 0 })
	public padding;

	@Prop()
	public viewPanelNotif = false;

	public viewOldNotif = false;
	public typeFilterNotif = -1;
	public listNotification: Notification[] = [];
	public listNotificationFiltred: Notification[] = [];

	public mounted(): void {
		this.listNotification = NotificationServiceInstance.listNotificationHeader;
		this.listNotificationFiltred = this.listNotification;
	}

	public click(e): void {
		e.preventDefault();
		e.stopPropagation();
	}

	public getTypeFailed(): number {
		return TypeNotification.Failed;
	}

	public getTypeSuccess(): number {
		return TypeNotification.Success;
	}

	public getTypeWarning(): number {
		return TypeNotification.Warning;
	}

	public getTypeInformation(): number {
		return TypeNotification.Information;
	}

	@Watch("listNotification")
	public refreshNotif(): void {
		this.$emit("updateNewNotif", this.listNotification.filter(notif => notif.isNew).length > 0);
		this.updateListFiltredNotif();
	}

	public switchViewNewNotif(): void {
		this.viewOldNotif = !this.viewOldNotif;
		this.updateListFiltredNotif();
	}

	public clickFailed(): void {
		this.typeFilterNotif = (this.typeFilterNotif !== TypeNotification.Failed ? this.typeFilterNotif = TypeNotification.Failed : this.typeFilterNotif = -1);
		this.updateListFiltredNotif();
	}

	public clickSuccess(): void {
		this.typeFilterNotif = (this.typeFilterNotif !== TypeNotification.Success ? this.typeFilterNotif = TypeNotification.Success : this.typeFilterNotif = -1);
		this.updateListFiltredNotif();
	}

	public clickWarning(): void {
		this.typeFilterNotif = (this.typeFilterNotif !== TypeNotification.Warning ? this.typeFilterNotif = TypeNotification.Warning : this.typeFilterNotif = -1);
		this.updateListFiltredNotif();
	}

	public clickInformation(): void {
		this.typeFilterNotif = (this.typeFilterNotif !== TypeNotification.Information ? this.typeFilterNotif = TypeNotification.Information : this.typeFilterNotif = -1);
		this.updateListFiltredNotif();
	}

	public updateListFiltredNotif(): void {
		this.listNotificationFiltred = this.listNotification.filter(notif => (this.viewOldNotif) ? !notif.isNew : notif.isNew);

		if (this.typeFilterNotif !== -1) {
			this.listNotificationFiltred = this.listNotificationFiltred.filter(notif => notif.type === this.typeFilterNotif);
		}
	}

	@Watch("viewPanelNotif")
	private updateViewAllNotif(): void {
		if (!this.viewPanelNotif) {
			this.viewOldNotif = false;
			this.typeFilterNotif = -1;
			NotificationServiceInstance.updateAllRead();
			this.updateListFiltredNotif();
		}
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/notification/notification-panel/notification-panel.ts